import { render } from "./processedit.vue?vue&type=template&id=48a27b6e&scoped=true"
import script from "./processedit.vue?vue&type=script&lang=js"
export * from "./processedit.vue?vue&type=script&lang=js"

import "./processedit.vue?vue&type=style&index=0&id=48a27b6e&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a27b6e"]])

export default __exports__